'use strict';

/*https://api.mapy.cz/doc/*/

/*global SMap */
/*global JAK */
/*global services*/
/*global MapAbstract*/
/*global MapMarkerSMap*/

function MapSMap(settings) {
    MapAbstract.call(this, settings);

    this.initSMap(settings);
}

MapSMap.prototype = $.extend({}, MapAbstract.prototype, {
    construtor: 'MapSMap',

    centerMap: function centerMap(position) {
        var _this = this;

        _this.map.setCenter(SMap.Coords.fromWGS84(position.lng, position.lat), false);
        return _this;
    },

    addMapItem: function addMapItem(mapItem, isTmp) {
        var _this = this;

        var options = {
            id: mapItem.itemID,
            position: {
                lat: mapItem.latitude,
                lng: mapItem.longitude
            }
        };

        //vycentrujeme mapa po vlozeni markeru
        if(_this.settings.mapCenterAfterInsertMarker) {
            _this.centerMap(options.position);
        }

        //vytvorime novy marker
        mapItem.marker = new MapMarkerSMap(options);

        mapItem.marker.setMap(_this.map);

        return mapItem;
    },

    //--------------------------------------------------------------------------

    initSMap: function initSMap(settings) {
        var _this = this;

        _this.initMap(settings);

        //zobrazime mapu
        var init = SMap.Coords.fromWGS84(_this.settings.initLongitude, _this.settings.initLatitude);
        _this.map = new SMap(JAK.gel(_this.settings.mapID + 'Map'), init, _this.settings.initZoom);
        _this.map.addDefaultLayer(SMap.DEF_BASE).enable();
        _this.map.addDefaultControls();

        return _this;
    }
});
